import { useIntl } from 'react-intl';

import { testId } from 'ui-components/services/testid-service';

import { CustomsField } from '../customs-field';
import { CustomsTextInput } from '../customs-text-input';
import messages from '../messages';

type CustomsSkuProps = {
  value?: string;
  onChange: (value: string | number) => void;
};

export const CustomsSku: React.FC<CustomsSkuProps> = ({ onChange, value = '' }) => {
  const intl = useIntl();
  return (
    <CustomsField label={messages.skuLabel}>
      <CustomsTextInput
        aria-label={intl.formatMessage(messages.skuLabel)}
        {...testId('customs-widget-sku-input')}
        onChange={onChange}
        type='text'
        value={value}
      />
    </CustomsField>
  );
};
